/**
 * 时间选择 - 单个日期行组件（从 BLW time-item.vue 迁移）
 * 展示一天的日期标题 + 该天的可选时间段网格
 */
import type { ExpertBookTimeDataItem, ExpertBookTimeListItem } from "../types";

interface TimeItemProps {
  /** 当前选中的时间范围 [startFullTime, endFullTime] */
  currentSelectArr: [number, number];
  /** 这一天的数据（含 list 时间段数组） */
  timeItem: ExpertBookTimeDataItem;
  onChoose: (item: ExpertBookTimeListItem) => void;
}

const PRIMARY = "#FE7A3A";

export default function TimeItem({ currentSelectArr, timeItem, onChoose }: TimeItemProps) {
  const handleChoose = (item: ExpertBookTimeListItem) => {
    if (!item.select) return;
    onChoose(item);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {/* 日期标题 */}
      <div style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        fontWeight: 600, fontSize: 16, color: "#333", position: "sticky", top: 0,
        background: "#fff", zIndex: 1,
      }}>
        {timeItem.name}
      </div>

      {/* 时间段网格 - 一行3个铺满 */}
      <div style={{ display: "flex", alignItems: "stretch", flexWrap: "wrap", gap: "8px 6px" }}>
        {timeItem.list.map((item) => {
          const isSelected = !!item.isSelected;
          const canSelect = item.select;

          const baseStyle: React.CSSProperties = {
            display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
            fontSize: 11, width: "calc(100% / 3 - 4px)", height: 54,
            border: canSelect ? "1.5px solid #333" : "1.5px solid #999",
            borderRadius: 8,
            cursor: canSelect ? "pointer" : "not-allowed",
            background: canSelect ? "#fff" : "#f8f8f8",
            color: canSelect ? "#333" : "#999",
            transition: "all .15s",
            boxSizing: "border-box",
          };

          // 选中态：橙色背景 + 白色文字 + 橙色边框
          if (isSelected) {
            Object.assign(baseStyle, {
              background: PRIMARY,
              borderColor: PRIMARY,
              color: "#fff",
              fontWeight: 500,
            });
          }

          return (
            <div key={item.timestamp} style={baseStyle} onClick={() => handleChoose(item)}>
              <span>{item.name}</span>
              <span style={{ fontSize: 10, opacity: 0.7 }}>{item.status}</span>
              {canSelect && (
                <span style={{
                  fontWeight: 700, fontSize: 12,
                  color: isSelected ? "#fff" : "#EF5738",
                }}>
                  ¥{Number(item.price || "0").toFixed(2)}
                </span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
